module.exports = __webpack_public_path__ + "onboarding-feed-http.1f2cf1738d4004296d61ec46c47bc647.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/library/empty/onboarding-feed-http.svg
// module id = 206860131625462
// module chunks = 1